import React from 'react';
import { Link } from 'react-router-dom';
import { usePathname } from '../../../hooks/use-pathname';
import { useI18n } from '../../../locales/i18n-context';
import { NAV_DATA } from '../../nav-config';
import { CONFIG } from '../../../global-config';
import './sidebar.css';

interface SidebarProps {
  onNavigate?: () => void;
}

/**
 * Sidebar Layout Component.
 * Uses semantic HTML and custom CSS for styling.
 */
export const Sidebar: React.FC<SidebarProps> = ({ onNavigate }) => {
  const pathname = usePathname();
  const { t } = useI18n();

  const isActive = (path: string) => (path === '/' ? pathname === '/' : pathname.startsWith(path));

  return (
    <nav className="cb-sidebar" aria-label="Main navigation">
      <div className="cb-sidebar__scroll">
        <ul className="cb-sidebar__nav">
          {NAV_DATA.map(({ path, icon: Icon, title }) => (
            <li key={path} className="cb-sidebar__item">
              <Link
                to={path}
                className={`cb-nav-link${isActive(path) ? ' cb-nav-link--active' : ''}`}
                onClick={onNavigate}
              >
                <span className="cb-nav-link__icon">
                  <Icon size={18} stroke={1.5} />
                </span>
                <span className="cb-nav-link__label">{t(title)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <footer className="cb-sidebar__footer">
        <div className="cb-sidebar__footer-content">
          <span className="cb-version">v{CONFIG.appVersion}</span>
          <span className="cb-footer-divider">|</span>
          <span className="cb-galactic-time">{t('nav.galacticTime')}</span>
        </div>
      </footer>
    </nav>
  );
};
